import { createRoot } from 'react-dom/client';
import smoothscroll from 'smoothscroll-polyfill';

import './index.scss';

import './fonts/stylesheet.css';
import App from './App';

smoothscroll.polyfill();
const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App/>);
document.querySelector('body').style.opacity = 1;